import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import AppInfo from "../AppInfo/AppInfo";

const About = () => {
  const useStyles = makeStyles((theme) => ({
    root: {
        margin: "1rem 0",
      },
      title: {
        color: "#536ade",
      },
    }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h5" className={classes.title}>
        About
      </Typography>
      <AppInfo></AppInfo>
    </div>
  );
};

About.propTypes = {};

export default About;
